import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function DocSearchActionNode({ id, data }) {
    return (
        <NodeComponent title="AI Knowledge" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
        </NodeComponent>
    );
}

